import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // for clearing

import persistConfig from '@config/redux-persist';
import AuthReducer from '@reducers/auth/AuthReducer';
import ClinicReducer from '@reducers/clinic/ClinicReducer';
import ClinicDirectoryReducer from '@reducers/clinic-directory/ClinicDirectoryReducer';
import CommunityBoardReducer from '@reducers/community-board/CommunityBoardReducer';
import DashboardReducer from '@reducers/dashboard/DashboardReducer';
import DentistReducer from '@reducers/dentist/DentistReducer';
import LabOrderReducer from '@reducers/lab-order/LabOrderReducer';
import LaboratoryReducer from '@reducers/laboratory/LaboratoryReducer';
import ProfileReducer from '@reducers/profile/ProfileReducer';
import ReferralReducer from '@reducers/referral/ReferralReducer';
import SharedReducer from '@reducers/shared/SharedReducer';
import UserReducer from '@reducers/user/UserReducer';

import { logoutAction } from './auth/AuthActionConfig';
import TutorialVideosReducer from './tutorial-videos/TutorialVideosReducer';

const reducers = combineReducers({
  Auth: persistReducer(persistConfig.auth, AuthReducer),
  User: UserReducer,
  Shared: persistReducer(persistConfig.shared, SharedReducer),
  Referral: persistReducer(persistConfig.referral, ReferralReducer),
  Dentist: DentistReducer,
  Profile: ProfileReducer,
  Dashboard: DashboardReducer,
  Clinic: ClinicReducer,
  ClinicDirectory: ClinicDirectoryReducer,
  Laboratory: LaboratoryReducer,
  LabOrder: LabOrderReducer,
  CommunityBoard: CommunityBoardReducer,
  Tutorial: TutorialVideosReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === logoutAction) {
    storage.removeItem('persist:root');
    storage.removeItem('persist:Auth');
    storage.removeItem('persist:Shared');
    storage.removeItem('persist:Referral');

    return reducers(undefined, action);
  }

  return reducers(state, action);
};

export default rootReducer;
